import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  DialogTemplateButtonComboStyleEnum
} from '@shared/components/templates/dialog-template/enums/dialog-template-button.enum';
import {
  DialogTemplateIconColorEnum
} from '@shared/components/templates/dialog-template/enums/dialog-template-icon-color.enum';

export interface ConfirmationDialogData {
  title: string;
  description: string;
  yesButtonText: string;
  noButtonText: string;
  hideCancelButton?: boolean;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  DialogTemplateIconColorEnum = DialogTemplateIconColorEnum;
  DialogTemplateButtonComboStyleEnum = DialogTemplateButtonComboStyleEnum;

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) {
  }

  onAction(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }

  static open(dialog: MatDialog, data: ConfirmationDialogData): MatDialogRef<ConfirmationDialogComponent, boolean> {
    return dialog.open(ConfirmationDialogComponent, {
      data: data,
    });
  }
}
